<div class="overlay hidden-print" [ngClass]="overlayClasses" (click)="closeModal(actionChoice.clickOutsideModal)"></div>

<div
  [ngClass]="modalClasses"
  *ngIf="active"
  role="dialog"
  [attr.aria-describedby]="describedById"
  [attr.aria-label]="labelValue">
  <button
    *ngIf="canDismiss"
    [ngClass]="{ reverse: reverseClose }"
    class="close hidden-print"
    (click)="closeModal(actionChoice.clickX)"
    aria-label="Close Modal">
    &times;
  </button>
  <div class="content" *ngIf="html" [innerHTML]="parsedHtml | sanitizeHtml"></div>
  <ng-content *ngIf="!html"></ng-content>
</div>
